import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function FubDealsIntegrationToggleWrapper(props: {
  children: React.ReactNode,
}) {
  return (
    <ToggleWrapper feature={ToggledFeature.FUB_DEALS_INTEGRATION}>
      {props.children}
    </ToggleWrapper>
  );
}
